import store from '..'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    addList (state, item) {
      let existItem = state.list.find(x => x.cartId === item.cartId)
      if (existItem) {
        existItem = item
      } else {
        state.list.push(item)
      }
    },
    delList (state, cartId) {
      state.list = state.list.filter(x => x.cartId !== cartId)
      localStorage.removeItem(cartId)
    },
    delAmenity (state, raCode) {
      const siteId = store.state.authentication.site
      const cartId = `cart_${siteId}_amenity`
      const cartAmenity = state.list.find(x => x.cartId === cartId)
      if (cartAmenity) {
        if (cartAmenity.items.length > 0) {
          cartAmenity.items = cartAmenity.items.filter(x => x.item !== raCode)
          if (cartAmenity.content) {
            cartAmenity.content = cartAmenity.content.filter(x => x.label !== raCode)
          }
          if (cartAmenity.items.length === 0) {
            state.list = state.list.filter(x => x.cartId !== cartId)
          }
        } else {
          state.list = state.list.filter(x => x.cartId !== cartId)
        }
      }
    }
  },
  actions: {
  },
  getters: {
    getList: state => state.list.filter(x => x.cartId.includes('cart_'))
  }
}
